// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Footer__pc_only___3Bqfu","sp_only":"Footer__sp_only___2MvXV","container":"Footer__container___1angh","content":"Footer__content___9x77Q"};